import React from 'react'

import {
  Button,
  Icon,
  Download,
  Spinner,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, bool, string } from 'prop-types'

function LoadingSpinner() {
  return (
    <div className="cgt-icon cgt-icon__icon cgt-icon--default cgt-icon--primary">
      <Spinner size="xsmall" classNames="cgt-spinner--inline" />
    </div>
  )
}

function FreeDownloadButton({
  onClick: handleClick = null,
  disabled = false,
  isDownloaded = false,
  isLoading = false,
  variant = 'primary-warning',
  label = 'Free Download',
  showIcon = false,
}) {
  const buttonType = isDownloaded ? 'secondary' : variant
  const buttonClass = isDownloaded
    ? 'pricing-area__actions-button pricing-area__actions-left-button'
    : 'pricing-area__actions-button pricing-area__actions-free-download-button'
  const buttonText = isDownloaded ? 'Download' : label
  let trailIcon = null

  if (isLoading) {
    trailIcon = <LoadingSpinner />
  } else if (showIcon) {
    trailIcon = <Icon svgComponent={Download} size="small" notSpaced />
  }

  return (
    <Button
      type={buttonType}
      customClass={buttonClass}
      size="large"
      onClick={handleClick}
      disabled={disabled || isLoading}
      aria-label={buttonText}
      trailIcon={trailIcon}
    >
      {buttonText}
    </Button>
  )
}

FreeDownloadButton.propTypes = {
  onClick: func,
  disabled: bool,
  isDownloaded: bool,
  isLoading: bool,
  variant: string,
  label: string,
  showIcon: bool,
}

export default FreeDownloadButton
